import axios from "./../../config/axios"
function store(data) {
    return axios().post("/auth/role-user", data)
}
function remove(user_id, role_id) {
    return axios().delete(`/auth/role-user/${user_id}/${role_id}`)
}
export default {
    store,
    remove
}